import Vue from 'vue'
import {
    getCookie
} from "@/utils/auth";
const axios = require("axios");
import {
    getQueryString
} from '@/utils/util';
export function downFileModal(url, file) {
    var size = 0;
    size = file.size ? Number(file.size) / 1024000 : 0;
    if (size >= 50) {
        createDownFile(url, file);
    } else {
        getDownFile(url, file);
    }
}

function getDownFile(url, file) {
    //使用axios进行请求后台，重点是{responseType: 'blob'} 的设置。
    axios.defaults.headers.common["sessionid"] = getCookie("Session-Id");
    axios
        .get(url.split('?')[0] + "?download=true", {
            responseType: "blob"
        })
        .then(response => {
            const link = document.createElement("a");
            let blob = new Blob([response.data], {
                type: "multipary/form-data"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", getQueryString('attname', url));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => {
            createDownFile(url, file, 1);
            console.log(error);
        });
}


function createDownFile(url, file, flag) {
    var title = "";
    if (flag == 1) {
        title = "浏览器下载出错，"
    } else {
        title = "文件过大，"
    }
    title += '请使用第三方工具下载'
    var content = '<span>' + title + '</span><br/>' + '<span>文件下载地址：<br/><textarea style="width:100%;resize:none;height: 80px;color:#606266" readonly id="biao1">'+url+'</textarea></textarea></span>'
    Vue.prototype.$alert(content, '下载提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '复制',
        customClass: 'customClassAlert',
        confirmButtonClass:'confirmButtonAlert',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                var Url2 = document.getElementById("biao1");
                Url2.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                Vue.prototype.$message({
                    type: "success",
                    message: "复制成功!",
                    duration: 3000,
                });
                done();
            } else {
                done();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/utils/downFile.js